import ListItemWithIcon from 'components/content/ListItemWithIcon';
import { useMemo } from 'react';

import SidebarSectionNoData from '../SidebarSectionNoData';
import SidebarSectionSkeleton from '../SidebarSectionSkeleton';
import styles from '../styles/SidebarSection.module.scss';

interface TeamsSidebarSectionProps {
    icon: 'user' | 'vehicle';
    header: string;
    items?: string[];
    count?: number;
    isLoading?: boolean;
}

const TeamsSidebarSection = ({ icon, header, items, count, isLoading }: TeamsSidebarSectionProps) => {
    const itemIcon = useMemo(() => {
        switch (icon) {
            case 'user':
                return 'rioglyph rioglyph-user';
            case 'vehicle':
                return 'rioglyph rioglyph-van-baseline';
            default:
                return;
        }
    }, [icon]);

    if (isLoading) {
        return <SidebarSectionSkeleton header={header} count={count} />;
    }

    if (!items?.length) {
        return <SidebarSectionNoData header={header} />;
    }

    return (
        <div className={styles.SidebarSection} data-testid={`sidebar-section-${header}`}>
            <p className={styles.SidebarSection__title} data-testid={`sidebar-section-${header}-title`}>
                {header}
            </p>
            <ul className={styles.SidebarSection__list}>
                {items.map(_ => (
                    <li
                        key={icon + _}
                        className={styles.SidebarSection__item}
                        data-testid={`sidebar-section-${header}-item`}
                    >
                        <ListItemWithIcon icon={itemIcon} label={_} />
                    </li>
                ))}
            </ul>
            <div className={styles.SidebarSection__footer} data-testid={`sidebar-section-${header}-total`}>
                <p className={styles.SidebarSection__footerText}>Total</p>
                {items.length}
            </div>
        </div>
    );
};

export default TeamsSidebarSection;
